import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import NftViewLayer from "../../components/NFT/NftViewLayer";

const NftViewPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="NFT View" />

                    <NftViewLayer />
               </MasterLayout>
          </>
     );
};

export default NftViewPage;
